/* Shared progressive enhancement. No customer details or location text enter analytics. */
(() => {
  'use strict';
  if (window.__availEveryday) return;
  window.__availEveryday = true;
  const header = document.querySelector('[data-av-platform]');
  if (!header) return;
  const platform = header.dataset.avPlatform;
  const params = new URLSearchParams(location.search);
  const track = (event, fields = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, journey: 'everyday_support', ...fields });
  };
  const route = (view, fields = {}) => {
    const q = new URLSearchParams(fields);
    if (platform === 'next') { q.set('view', view); return '/homepage-prototype?' + q; }
    if (view === 'stores') return '/pages/find-us-instore?' + q;
    q.set('view', 'avail-' + view); return '/?' + q;
  };
  const productURL = p => (platform === 'next' ? 'https://avail.design' : '') + '/products/' + p.handle + (platform === 'next' ? '?preview_theme_id=146453725250' : '');
  const setURL = values => {
    const url = new URL(location.href);
    for (const [key, value] of Object.entries(values)) {
      if (value && value !== 'all') url.searchParams.set(key, value); else url.searchParams.delete(key);
    }
    history.pushState(null, '', url);
  };
  const el = (tag, text, cls) => { const n = document.createElement(tag); if (text) n.textContent = text; if (cls) n.className = cls; return n; };
  const a = (href, text, cls) => { const n = el('a', text, cls); n.href = href; return n; };
  const normalise = s => s.trim().toLowerCase().replace(/\s+/g, ' ');
  const codeCorrection = s => /^[a-z0-9-]+$/i.test(s) && /[0-9]/.test(s) ? s.replace(/o/gi, '0') : /^so\d/i.test(s) ? s.replace(/^so/i, 's0') : s;
  let catalogue;
  const ready = fetch(header.dataset.avCatalogue).then(r => { if (!r.ok) throw new Error('Catalogue unavailable'); return r.json(); }).then(d => { catalogue = d; return d; });

  document.addEventListener('click', e => {
    const item = e.target.closest('[data-av-event]');
    if (item) track(item.dataset.avEvent, { item_id: item.dataset.sku || undefined, product_group: item.dataset.kind || undefined, item_brand: item.dataset.brand || undefined });
  });
  // Finish discs on product cards: pointing at a disc previews that finish and its SKU in the label.
  const swatchLabel = (disc, reset) => {
    const box = disc.closest('.av-swatches'), label = box && box.querySelector('[data-av-swatch-label]');
    if (!label) return;
    if (!label.dataset.current) label.dataset.current = label.textContent;
    label.textContent = reset ? label.dataset.current : [disc.dataset.finish, disc.dataset.sku ? 'SKU ' + disc.dataset.sku : ''].filter(Boolean).join(' · ');
  };
  for (const type of ['mouseover', 'focusin']) document.addEventListener(type, e => { const disc = e.target.closest && e.target.closest('.av-swatch'); if (disc) swatchLabel(disc, false); });
  for (const type of ['mouseout', 'focusout']) document.addEventListener(type, e => { const disc = e.target.closest && e.target.closest('.av-swatch'); if (disc && !disc.contains(e.relatedTarget)) swatchLabel(disc, true); });
  const menus = [...header.querySelectorAll('[data-av-menu]')];
  const mobileMenu = header.querySelector('.av-mobile-nav-toggle');
  const desktop = matchMedia('(min-width: 901px)');
  let menuTimer;
  const menuPosition = () => header.style.setProperty('--av-menu-top', Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)) + 'px');
  const menuState = () => header.toggleAttribute('data-av-menu-open', menus.some(m => m.open) || !!mobileMenu?.open);
  const closeMenus = () => {
    clearTimeout(menuTimer);
    menus.forEach(m => { m.open = false; });
    if (mobileMenu) mobileMenu.open = false;
    menuState();
  };
  menus.forEach(menu => {
    menu.querySelector('summary').addEventListener('click', () => clearTimeout(menuTimer));
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        menus.forEach(other => { if (other !== menu) other.open = false; });
        menuPosition();
      }
      menuState();
    });
    menu.addEventListener('pointerenter', e => {
      if (!desktop.matches || e.pointerType !== 'mouse') return;
      clearTimeout(menuTimer);
      menuTimer = setTimeout(() => { menu.open = true; }, 180);
    });
    menu.addEventListener('pointerleave', e => {
      if (!desktop.matches || e.pointerType !== 'mouse') return;
      clearTimeout(menuTimer);
      menuTimer = setTimeout(() => {
        if (!menu.contains(document.activeElement)) { menu.open = false; menuState(); }
      }, 260);
    });
    menu.querySelector('[data-av-menu-close]')?.addEventListener('click', () => {
      clearTimeout(menuTimer); menu.open = false; menu.querySelector('summary').focus(); menuState();
    });
  });
  mobileMenu?.addEventListener('toggle', () => {
    menuPosition();
    if (!mobileMenu.open) menus.forEach(m => { m.open = false; });
    menuState();
  });
  header.addEventListener('click', e => { if (e.target.closest('a')) closeMenus(); });
  document.addEventListener('click', e => { if (!header.contains(e.target)) closeMenus(); });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const open = menus.find(m => m.open) || (mobileMenu?.open ? mobileMenu : null);
    if (open) { e.preventDefault(); clearTimeout(menuTimer); open.open = false; open.querySelector('summary').focus(); menuState(); }
  });
  header.addEventListener('focusout', e => {
    // Focus briefly moves to body between controls. Keep the panel open while
    // the pointer or keyboard moves from its summary to one of its links.
    if (e.relatedTarget) {
      if (!header.contains(e.relatedTarget)) closeMenus();
    } else {
      setTimeout(() => { if (!header.contains(document.activeElement)) closeMenus(); }, 0);
    }
  });
  desktop.addEventListener('change', closeMenus);
  window.addEventListener('resize', menuPosition);

  const search = document.querySelector('[data-av-search]');
  if (search) {
    const input = search.querySelector('input[type=search]');
    const list = search.querySelector('[role=listbox]');
    const status = search.querySelector('[role=status]');
    let timer, controller, selected = -1, results = [], serial = 0;
    const hide = () => { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); selected = -1; };
    // Dave wants the thumbnails and the collections-plus-products split from the current live search.
    const thumb = p => {
      const src = p.image || (p.featured_image && p.featured_image.url) || '';
      if (!src) return '';
      if (/width=\d+/.test(src)) return src.replace(/width=\d+/, 'width=120');
      return src + (src.includes('?') ? '&' : '?') + 'width=120';
    };
    const money = value => { const n = Number(value); return Number.isFinite(n) && n > 0 ? '$' + n.toFixed(2) : ''; };
    const group = text => { const li = el('li', text, 'av-search-group'); li.setAttribute('role', 'presentation'); list.append(li); };
    const option = (i, link) => { const li = el('li'); li.setAttribute('role', 'option'); li.id = 'av-result-' + i; li.setAttribute('aria-selected', 'false'); link.tabIndex = -1; li.append(link); list.append(li); };
    const paint = (items, correction = '', collections = []) => {
      const found = collections.slice(0, 3), products = items.slice(0, 6);
      results = [...found, ...products]; selected = -1; list.replaceChildren();
      if (correction) { const hint = el('li', 'Showing matches for ' + correction.toUpperCase(), 'av-search-hint'); hint.setAttribute('role', 'presentation'); list.append(hint); }
      if (found.length) {
        group('Collections');
        found.forEach((c, i) => option(i, a(c.url, c.title, 'av-search-collection')));
      }
      if (products.length) {
        if (found.length) group('Products');
        products.forEach((p, i) => {
          const link = a(p.url || productURL(p), '', 'av-search-product');
          const photo = el('span', '', 'av-search-thumb'), src = thumb(p);
          if (src) { const img = el('img'); img.src = src; img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy'; photo.append(img); }
          const body = el('span', '', 'av-search-body');
          const brand = p.vendor || p.brand;
          if (brand) body.append(el('small', brand, 'av-search-brand'));
          body.append(el('span', p.title, 'av-search-title'));
          const meta = [p.sku, money(p.price)].filter(Boolean).join(' · ');
          if (meta) body.append(el('small', meta));
          link.append(photo, body);
          option(found.length + i, link);
        });
      }
      if (!results.length) { const li = el('li', 'No suggestions. Press Search to search the full catalogue.', 'av-search-hint'); li.setAttribute('role', 'presentation'); list.append(li); }
      list.hidden = false; input.setAttribute('aria-expanded', 'true'); status.textContent = results.length + ' suggestions.';
    };
    const suggestions = async term => {
      const request = ++serial;
      const d = await ready;
      const corrected = codeCorrection(term);
      if (platform === 'shopify') {
        if (controller) controller.abort(); controller = new AbortController();
        const get = async q => { const r = await fetch('/search/suggest.json?' + new URLSearchParams({ q, 'resources[type]': 'product,collection', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last' }), { signal: controller.signal }); if (!r.ok) throw new Error('Search unavailable'); const j = await r.json(); return { products: j.resources.results.products || [], collections: j.resources.results.collections || [] }; };
        try { let found = await get(term), correctedUsed = ''; if (!found.products.length && !found.collections.length && corrected !== term) { found = await get(corrected); correctedUsed = corrected; } if (request === serial) paint(found.products, correctedUsed, found.collections); return; } catch (error) { if (error.name === 'AbortError') return; }
      }
      const matches = q => d.products.filter(p => normalise(p.title + ' ' + p.sku).includes(normalise(q)));
      let items = matches(term), correctedUsed = '';
      if (!items.length && corrected !== term) { items = matches(corrected); correctedUsed = corrected; }
      if (request === serial) paint(items, correctedUsed);
    };
    input.addEventListener('input', () => { clearTimeout(timer); if (input.value.trim().length < 2) { serial++; hide(); return; } timer = setTimeout(() => suggestions(input.value.trim()).catch(() => { status.textContent = 'Suggestions unavailable. Use Search to continue.'; hide(); }), 180); });
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') { serial++; hide(); return; }
      if (list.hidden || !results.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); selected = (selected + (e.key === 'ArrowDown' ? 1 : -1) + results.length) % results.length;
        list.querySelectorAll('[role=option]').forEach((n, i) => n.setAttribute('aria-selected', String(i === selected)));
        input.setAttribute('aria-activedescendant', 'av-result-' + selected);
      } else if (e.key === 'Enter' && selected >= 0) { e.preventDefault(); track('hero_search', { search_method: 'suggestion' }); location.href = results[selected].url || productURL(results[selected]); }
    });
    search.addEventListener('submit', () => track('hero_search', { search_method: 'full_catalogue' }));
    list.addEventListener('click', e => { if (e.target.closest('a')) track('hero_search', { search_method: 'suggestion' }); });
    document.addEventListener('click', e => { if (!search.contains(e.target)) { serial++; hide(); } });
  }

  const browse = document.querySelector('[data-av-browse-filters]');
  if (browse) {
    const names = Object.fromEntries([...browse.elements.area.options].map(o => [o.value, o.text]));
    const apply = (update = false) => {
      const area = browse.elements.area.value, type = browse.elements.type.value;
      let count = 0;
      document.querySelectorAll('[data-av-product-list] [data-av-product]').forEach(card => {
        const areas = card.dataset.areas.split(' ');
        const match = (area === 'all' || areas.includes(area)) && (type === 'all' || card.dataset.kind === type);
        card.hidden = !match; if (match) count++;
      });
      const categoryNote = document.querySelector('[data-av-category-note]');
      const pending = ['outdoor', 'dementia'].includes(area);
      categoryNote.hidden = !pending;
      categoryNote.textContent = area === 'outdoor' ? 'Outdoor use needs product-specific checks for exposure, surfaces and fixing. Contact Avail with your intended location so we can check a suitable option.' : 'Dementia support needs an individual assessment. Ask your occupational therapist or adviser about the need, then Avail can help check product information.';
      document.querySelector('[data-av-browse-title]').textContent = area === 'all' ? (type === 'portable' ? 'Portable supports.' : type === 'installed' ? 'Fixed, installed supports.' : 'Browse supports.') : names[area] + '.';
      document.querySelector('[data-av-count]').textContent = count + ' product ' + (count === 1 ? 'family' : 'families') + ' shown';
      document.querySelector('[data-av-empty]').hidden = count !== 0;
      if (update) { setURL({ area, type }); track('support_browse', { support_area: area, product_group: type, result_count: count }); }
    };
    const restore = () => { const p = new URLSearchParams(location.search); browse.elements.area.value = names[p.get('area')] ? p.get('area') : 'all'; browse.elements.type.value = [...browse.elements.type.options].some(o => o.value === p.get('type')) ? p.get('type') : 'all'; apply(); };
    browse.addEventListener('submit', e => { e.preventDefault(); apply(true); });
    window.addEventListener('popstate', restore); restore();
    if (params.get('area') === 'other') { document.querySelector('.av-other').open = true; document.querySelector('[data-av-browse-title]').textContent = 'Other supports.'; document.querySelector('[data-av-browse-lead]').textContent = 'Choose a support need or accessory category below.'; }
  }

  const storeForm = document.querySelector('[data-av-store-filters]');
  if (storeForm) {
    const output = document.querySelector('[data-av-store-results]'), count = document.querySelector('[data-av-store-count]'), more = document.querySelector('[data-av-more]');
    let limit = 12, matches = [];
    const render = () => {
      output.replaceChildren(); count.textContent = matches.length + ' matching ' + (matches.length === 1 ? 'store' : 'stores'); more.hidden = matches.length <= limit;
      for (const store of matches.slice(0, limit)) {
        const card = el('article', '', 'av-store');
        const detail = el('div'); detail.append(el('p', store.kind === 'mobility' ? 'Mobility store' : 'Bathroom showroom', 'av-kicker'), el('h2', store.name), el('p', [store.suburb, store.state, store.postcode].filter(Boolean).join(', ')));
        if (store.address) { detail.append(el('p', store.address)); const map = a('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent([store.name, store.address, store.suburb, store.state, store.postcode].join(' ')), 'Check store details & directions', 'av-textlink'); map.target = '_blank'; map.rel = 'noopener'; detail.append(map); }
        else detail.append(el('p', 'Street address is not listed. Contact Avail to confirm this showroom before travelling.', 'av-note'));
        const displays = el('div', '', 'av-display-list');
        if (store.products.length) {
          displays.append(el('h3', 'Products listed on display'));
          for (const sku of store.products) { const p = catalogue.products.find(p => p.sku === sku); if (!p) continue; const link = a(productURL(p), '', 'av-display-product'); const image = el('img'); image.src = p.image; image.alt = ''; image.loading = 'lazy'; image.width = 64; image.height = 64; link.append(image, el('span', p.title + (sku === 'S01SAW' ? ' (white)' : '') + ' · ' + sku)); link.addEventListener('click', () => track('display_product_selected', { item_id: sku, store_id: store.id, product_group: p.kind })); displays.append(link); }
        }
        if (store.kind === 'bathroom' || store.grabRails) { displays.append(el('h3', 'Ranges listed')); const range = store.kind === 'bathroom' ? store.displayText : 'Grab rails'; displays.append(el('p', range || 'Display range not supplied.')); if (range) displays.append(a((platform === 'next' ? 'https://avail.design' : '') + '/collections/' + (store.kind === 'bathroom' ? 'tapwareaccessories' : 'grabrails'), 'Explore this product category', 'av-textlink')); displays.append(el('p', 'A range listing does not confirm a specific model or finish on display.', 'av-fine')); }
        if (!store.products.length && !store.displayText) displays.append(el('p', 'Displayed products have not been supplied. Ask Avail to check.'));
        displays.append(el('p', 'Confirm the current display and opening hours with the store before visiting.', 'av-fine')); card.append(detail, displays); output.append(card);
      }
      if (!matches.length) { const empty = el('div', '', 'av-empty'); empty.append(el('h2', 'No matching display is listed.'), el('p', 'Try a nearby suburb, clear the product filter, or call Avail to help find and confirm a display.'), a('tel:1300945720', 'Call 1300 945 720', 'av-button')); output.append(empty); }
    };
    const apply = (update = false) => {
      const values = Object.fromEntries(new FormData(storeForm)), q = normalise(values.location || '');
      matches = catalogue.stores.filter(s => {
        const productMatch = values.product === 'all' || (values.product === 'grab-rails' ? s.grabRails || /grab.?rail/i.test(s.displayText) : values.product === 'mecca-care' ? /mecca\s*care/i.test(s.displayText) : s.products.includes(values.product));
        return (values.kind === 'all' || s.kind === values.kind) && productMatch && (!q || normalise([s.name, s.address, s.suburb, s.state, s.postcode].join(' ')).includes(q));
      });
      limit = 12; render();
      if (update) { setURL(values); track('store_finder_search', { store_type: values.kind, display_product: values.product, location_provided: Boolean(q), result_count: matches.length }); }
    };
    const restore = () => { const p = new URLSearchParams(location.search); for (const key of ['location', 'kind', 'product']) { const input = storeForm.elements[key]; const val = p.get(key) || (key === 'location' ? '' : key === 'kind' && location.pathname.includes('bathroom-showrooms') ? 'bathroom' : 'all'); input.value = input.tagName === 'SELECT' && ![...input.options].some(o => o.value === val) ? 'all' : val; } apply(); };
    ready.then(() => { restore(); window.addEventListener('popstate', restore); }).catch(() => { count.textContent = 'The store list could not load. Call 1300 945 720 and we can help.'; });
    storeForm.addEventListener('submit', e => { e.preventDefault(); if (catalogue) apply(true); });
    storeForm.addEventListener('reset', () => setTimeout(() => { if (catalogue) apply(true); }, 0));
    more.addEventListener('click', () => { const first = limit; limit += 12; render(); const result = output.children[first]; if (result) { result.tabIndex = -1; result.focus(); } });
  }

  const dialog = document.querySelector('[data-av-dialog]');
  const player = dialog && dialog.querySelector('[data-av-player]');
  let opener;
  if (dialog) {
    const stop = () => { player.querySelectorAll('video').forEach(v => v.pause()); player.replaceChildren(); if (opener && document.contains(opener)) opener.focus(); };
    dialog.addEventListener('close', stop);
    dialog.querySelector('[data-av-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    document.addEventListener('click', async e => {
      const button = e.target.closest('[data-av-video],[data-av-youtube]'); if (!button) return;
      opener = button; player.replaceChildren(); dialog.showModal();
      if (button.dataset.avYoutube) {
        dialog.querySelector('h2').textContent = 'Calibre grab rail installation for stud walls';
        const iframe = el('iframe'); iframe.src = 'https://www.youtube-nocookie.com/embed/' + button.dataset.avYoutube + '?cc_load_policy=1&cc_lang_pref=en'; iframe.title = 'Avail Calibre grab rail installation for stud walls'; iframe.allow = 'fullscreen; encrypted-media; picture-in-picture'; iframe.allowFullscreen = true; player.append(iframe);
        const fallback = a('https://www.youtube.com/watch?v=' + button.dataset.avYoutube, 'Watch on YouTube if the player does not load', 'av-textlink'); fallback.target = '_blank'; fallback.rel = 'noopener'; player.append(fallback);
        track('setup_video_open', { video_id: button.dataset.avYoutube }); return;
      }
      try {
        const d = await ready, video = d.videos.find(v => v.id === button.dataset.avVideo);
        if (!dialog.open) return;
        dialog.querySelector('h2').textContent = video.title;
        const node = el('video'); node.controls = true; node.playsInline = true; node.preload = 'metadata'; node.poster = video.poster; node.crossOrigin = 'anonymous'; node.src = video.url;
        const captions = el('track'); captions.kind = 'captions'; captions.srclang = 'en'; captions.label = 'English'; captions.default = true;
        captions.src = platform === 'next' ? '/homepage-everyday/' + video.id + '.vtt' : new URL('av-' + video.id + '.vtt', new URL(header.dataset.avCatalogue, location.href)).href;
        node.append(captions); player.append(node); track('setup_video_open', { video_id: video.id });
      } catch { player.append(el('p', 'This video could not load. Please use the written setup guidance or call Avail.')); }
    });
  }
  // Expose only deterministic helpers for focused regression checks.
  window.AvailEveryday = { codeCorrection, normalise };
})();
